import { useState } from "react";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { request } from "../../store/modules/RequestStore";
import { uploadFile } from "../../store/modules/RuleStore";
import { uploadRequestFile } from "../../store/modules/MarketPlaceStore";
import { toast } from "react-toastify";

// icons
import LoadedFile from "../../components/RequestPage/TabFiles/File";

import {
  AddFile,
  AddFileHover,
} from "../../components/RequestPage/TabFiles/FileElements";

//scrollbar
import Scrollbar from "../../components/widgets/Scrollbar";

//tooltip
import Tooltip from "../../components/widgets/Tooltip";
import { useTranslation } from "react-i18next";

const TabFiles = ({
  ID,
  uploadedFiles,
  requestState,
  modalRemoveFile,
  setModalRemoveFile,
  filesToRemoveList,
  setfilesToRemoveList,
  folder,
  canUpload
}: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation()
  // const requestState = useSelector(request);

  const [file, setFile] = useState(false);
  const [hover, setHover] = useState(false);

  const [select, setSelect] = useState(false);
  
  const handleChange = (files: FileList) => {
    for (var i = 0; i < files.length; i++) {
      let file = files[i];
      const max = 20000000;
      if (file.size <= max) {
        toast.dismiss();
        dispatch(uploadFile(ID, file));
        setFile(false);
      } else {
        toast.error(`${t("requestDetail.tabFiles.archive")} ${file.name} ${t("requestDetail.tabFiles.maxSize")}`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        setFile(false);
      }
    }
  };

  return (
    <div
      className="relative flex flex-col px-0 lg:px-8"
      style={{ height: "14rem" }}
    >
      {/* h-16 */}
      <div className="flex flex-row-reverse items-center  gap-4">
        {requestState.active.StatusName !== "Cerrada" && canUpload === true && (
          <Tooltip title={t("requestDetail.tabFiles.uploadArchive")}>
            <label
              // onMouseEnter={() => setHover(true)}
              // onMouseLeave={() => setHover(false)}
              className={`cursor-pointer justify-self-center`}
            >
              {file ? (
                <Loader
                  type="TailSpin"
                  color="#4f46e5"
                  height={60}
                  width={60}
                />
              ) : !hover ? (
                <AddFile />
              ) : (
                <AddFileHover />
              )}

              <input
                type="file"
                name="adjunto"
                multiple
                className="hidden"
                onChange={(e) => {
                  if (e.target.files !== null) {
                    handleChange(e.target.files);
                  }
                }}
              />
            </label>
          </Tooltip>
        )}
        {/* <Tooltip title="Seleccionar archivos">
          <button onClick={() => setSelect(!select)}>
            <Select />
          </button>
        </Tooltip>
        {select && filesToRemoveList.length > 0 && (
          <Tooltip title="Eliminar archivos seleccionados">
            <button onClick={() => setModalRemoveFile(!modalRemoveFile)}>
              <Remove />
            </button>
          </Tooltip>
        )} */}
      </div>
      <div></div>
      {uploadedFiles.length > 0 ? (
        <Scrollbar>
          <div className="w-full flex flex-col gap-6 md:grid md:grid-cols-2 md:gap-3 lg:grid lg:grid-cols-6 lg:gap-5 items-center px-6">
            {uploadedFiles.map((item: any, index: any) => {
              return (
                <LoadedFile
                  key={index}
                  file={item}
                  folder={folder}
                  //   select={select}
                  filesToRemoveList={filesToRemoveList}
                  setfilesToRemoveList={setfilesToRemoveList}
                  ID={ID}
                />
              );
            })}
          </div>
        </Scrollbar>
      ) : (
        <div className="flex flex-col items-center justify-center h-96">
          {/* <img className="w-48" src={noFiles} alt="asset" /> */}
          <p className="text-sm sm:text-md md:text-lg">
            {t("requestDetail.tabFiles.empty")}
          </p>
        </div>
      )}
    </div>
  );
};

export default TabFiles;
